/* BYON ronda 11 · Ficha (D1, SEO-2 A). Lo carga sections/byon-pdp-assets.liquid (defer) SOLO con faq_visible o
   tabla_visible encendidos. Sin librerías.
   1. Preguntas frecuentes visibles (snippets/byon-pdp-faq.liquid):
      - evento K1 faq_open {item_id, faq_index} cuando el cliente abre una pregunta (no al cargar);
      - #faq-N en la URL abre esa pregunta y la deja a la vista (scroll-margin-top de 96 px en el CSS).
   2. Información nutricional visible (snippets/byon-pdp-nutrition.liquid): "Ver tabla completa" / "Ver menos"
      (en mobile se ven 6 filas; las demás siguen en el HTML). */
(function () {
  'use strict';
  if (window.byonPdpContent) return;
  window.byonPdpContent = true;
  var d = document;
  function track(ev, p) { (window.byonTrack || function () {})(ev, p); }
  function closest(el, s) { return el && el.closest ? el.closest(s) : null; }

  /* ---------- 1. Preguntas frecuentes ---------- */
  var faq = d.querySelector('[data-byon-faq]');
  if (faq) {
    faq.addEventListener('click', function (e) {
      var sum = closest(e.target, 'summary');
      if (!sum || !faq.contains(sum)) return;
      var item = sum.parentNode;
      if (!item || !item.hasAttribute('data-byon-faq-item')) return;
      /* El clic llega antes de que <details> cambie: si está cerrado, se va a abrir. */
      if (!item.open) {
        track('faq_open', {
          item_id: String(faq.getAttribute('data-item-id') || ''),
          faq_index: parseInt(item.getAttribute('data-byon-faq-item'), 10) || 0
        });
      }
    });
    var openFromHash = function () {
      var m = /^#faq-(\d+)$/.exec(window.location.hash || '');
      if (!m) return;
      var item = d.getElementById('faq-' + m[1]);
      if (!item || !faq.contains(item)) return;
      item.open = true;
      if (item.scrollIntoView) item.scrollIntoView({ block: 'start' });
    };
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  }

  /* ---------- 2. Tabla nutricional: ver completa / ver menos ---------- */
  d.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-byon-nutri-more]');
    if (!btn) return;
    var box = closest(btn, '[data-byon-nutri]');
    if (!box) return;
    var open = box.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Ver menos' : 'Ver tabla completa';
  });
})();
